module.exports = __webpack_public_path__ + "static/img/logo_sprite.2c9a43b.webp";